import { isElectron } from '../../shared/helpers/platform';

const audioPath =
  process.env.NODE_ENV === 'production' && isElectron()
    ? 'static://assets/audio/dtmf'
    : './assets/audio/dtmf';

const tones = {
  0: new Audio(`${audioPath}/dtmf-0.wav`),
  1: new Audio(`${audioPath}/dtmf-1.wav`),
  2: new Audio(`${audioPath}/dtmf-2.wav`),
  3: new Audio(`${audioPath}/dtmf-3.wav`),
  4: new Audio(`${audioPath}/dtmf-4.wav`),
  5: new Audio(`${audioPath}/dtmf-5.wav`),
  6: new Audio(`${audioPath}/dtmf-6.wav`),
  7: new Audio(`${audioPath}/dtmf-7.wav`),
  8: new Audio(`${audioPath}/dtmf-8.wav`),
  9: new Audio(`${audioPath}/dtmf-9.wav`),
  '#': new Audio(`${audioPath}/dtmf-pound.wav`),
  '*': new Audio(`${audioPath}/dtmf-star.wav`),
};

export default tones;
